<ion-refresher slot="fixed" (ionRefresh)="doRefresh($event)">
	<ion-refresher-content
		pullingIcon="chevron-down-circle-outline"
		pullingText="Pull to refresh"
		refreshingSpinner="circles"
		refreshingText="Refreshing..."
	></ion-refresher-content>
</ion-refresher>

<!-- Bottom Sheet Header Design -->
<div class="bottom-sheet-header-container" *ngIf="userProfile.emailId">
	<div *ngIf="isApproved()">
		<app-admin-remarks [form]="pageSpecificFormObject"></app-admin-remarks>
	</div>

	<!-- Minimal Top Header Bar -->
	<div class="minimal-header-bar" (click)="toggleBottomSheet()">
		<div class="header-left">
			<!-- Form Status Icon Only -->
			<div class="compact-status" *ngIf="getStatusLabel() !== undefined">
				<!-- <div class="status-icon-wrapper" [class]="getStatusClassName()">
          <i [class]="getStatusIcon()"></i>
        </div> -->
			</div>
		</div>

		<div class="header-center">
			<!-- User Avatar and Name -->
			<div class="user-summary">
				<div class="user-avatar-small">
					<i class="fas fa-user-circle"></i>
				</div>
				<span class="user-name-short">
					<span *ngIf="userProfile.salutation">{{ userProfile.salutation.label }}. </span>
					{{ userProfile.firstName }} {{ userProfile.lastName }}
				</span>
			</div>
		</div>

		<div class="header-right">
			<!-- Info Indicator -->
			<div class="info-indicator">
				<i class="fas fa-chevron-up" [class.rotated]="!isBottomSheetOpen"></i>
				<div class="notification-badges">
					<!-- Alert notification badge -->
					<div
						class="notification-dot alert-dot"
						*ngIf="
							showSharedWithNames ||
							showResentWithNames ||
							showRecallWithNames ||
							showSubmitForApprovalWithNames ||
							showRejectionReason ||
							showCoordinatorRemarks
						"
					>
					</div>
				</div>
			</div>
		</div>
	</div>

	<!-- Bottom Sheet Overlay -->
	<div class="bottom-sheet-overlay" [class.active]="isBottomSheetOpen" (click)="closeBottomSheet()"> </div>

	<!-- Bottom Sheet Content -->
	<div class="bottom-sheet" [class.open]="isBottomSheetOpen">
		<!-- Bottom Sheet Handle -->
		<div class="bottom-sheet-handle">
			<div class="handle-bar"></div>
		</div>

		<!-- Bottom Sheet Header -->
		<div class="bottom-sheet-header">
			<h6 class="sheet-title">Form Details</h6>
			<button type="button" class="close-btn" (click)="closeBottomSheet()" aria-label="Close">
				<i class="fas fa-times"></i>
			</button>
		</div>

		<!-- Bottom Sheet Body -->
		<div class="bottom-sheet-body">
			<!-- Status and Actions Section -->
			<div class="sheet-section status-section">
				<div class="section-header">
					<i class="fas fa-info-circle"></i>
					<span>Status & Actions</span>
				</div>

				<div class="section-content">
					<!-- Full Status Badge -->
					<div class="full-status-badge" *ngIf="getStatusLabel() !== undefined">
						<ion-badge [color]="getStatusClassName()" class="status-badge">
							<i class="fas fa-circle-info me-1"></i>
							{{ getStatusLabel() }}
						</ion-badge>
					</div>

					<!-- PDF Export and College Type -->
					<div class="action-buttons">
						<div class="college-info" *ngIf="pageSpecificFormObject.collegeType">
							<i class="fas fa-building"></i>
							<span>{{ pageSpecificFormObject.collegeType }}</span>
						</div>

						<div class="pdf-export" *ngIf="canPrint()">
							<button
								type="button"
								class="pdf-btn"
								*ngIf="!pdfLoading"
								(click)="exportPdf()"
								[disabled]="!canDownloadPDF()"
							>
								<i class="far fa-file-pdf"></i>
								<span>Export PDF</span>
							</button>

							<div class="pdf-loading" *ngIf="pdfLoading">
								<ion-spinner name="dots" color="primary"></ion-spinner>
								<span>Generating PDF...</span>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- Enhanced Alert Messages Section -->

			<!-- Interactive Status Indicators -->
			<div class="status-actions">
				<button
					type="button"
					class="sheet-action-btn shared-btn"
					*ngIf="pageSpecificFormObject.sharedWith != null && pageSpecificFormObject.status == 'SHARED'"
					(click)="toggleShowSharedWithNames()"
					[attr.aria-expanded]="showSharedWithNames"
				>
					<span>
						<i class="fas fa-share-alt"></i>
						View Sharing Details
					</span>
					<i class="fas fa-chevron-down expand-icon" [class.expanded]="showSharedWithNames"></i>
				</button>

				<button
					type="button"
					class="sheet-action-btn resent-btn"
					*ngIf="pageSpecificFormObject.status == 'RESENT'"
					(click)="toggleShowResentWithNames()"
					[attr.aria-expanded]="showResentWithNames"
				>
					<span>
						<i class="fas fa-undo"></i>
						View Return Reason
					</span>
					<i class="fas fa-chevron-down expand-icon" [class.expanded]="showResentWithNames"></i>
				</button>

				<button
					type="button"
					class="sheet-action-btn recalled-btn"
					*ngIf="pageSpecificFormObject.status == 'RECALLED'"
					(click)="toggleShowRecallWithNames()"
					[attr.aria-expanded]="showRecallWithNames"
				>
					<span>
						<i class="fas fa-arrow-rotate-left"></i>
						View Recall Reason
					</span>
					<i class="fas fa-chevron-down expand-icon" [class.expanded]="showRecallWithNames"></i>
				</button>

				<button
					type="button"
					class="sheet-action-btn approval-btn"
					*ngIf="pageSpecificFormObject.status == 'SUBMITTED_FOR_APPROVAL'"
					(click)="toggleShowSubmitForApprovalWithNames()"
					[attr.aria-expanded]="showSubmitForApprovalWithNames"
				>
					<span>
						<i class="fas fa-paper-plane"></i>
						View Approval Details
					</span>
					<i class="fas fa-chevron-down expand-icon" [class.expanded]="showSubmitForApprovalWithNames"></i>
				</button>

				<button
					type="button"
					class="sheet-action-btn reverted-btn"
					*ngIf="pageSpecificFormObject.status == 'REVERTED'"
					(click)="toggleShowRejectionReason()"
					[attr.aria-expanded]="showRejectionReason"
				>
					<span>
						<i class="fas fa-exclamation-triangle"></i>
						View Revert Reason
					</span>
				</button>

				<button
					type="button"
					class="sheet-action-btn reverted-btn"
					*ngIf="isCoordinatorApprovedStatus() && pageSpecificFormObject.rejectionMessage"
					(click)="toggleShowCoordinatorRemarks()"
					[attr.aria-expanded]="showCoordinatorRemarks"
				>
					<span>
						<i class="fas fa-comment-alt"></i>
						View Remarks
					</span>
					<i class="fas fa-chevron-down expand-icon" [class.expanded]="showCoordinatorRemarks"></i>
				</button>
			</div>

			<div
				class="sheet-section alerts-section"
				*ngIf="
					showSharedWithNames ||
					showResentWithNames ||
					showRecallWithNames ||
					showSubmitForApprovalWithNames ||
					showRejectionReason ||
					showCoordinatorRemarks
				"
			>
				<div class="section-header">
					<i class="fas fa-bell"></i>
					<span>Messages & Alerts</span>
				</div>

				<div class="section-content">
					<div class="status-messages-container">
						<!-- Recalled Message -->
						<div class="status-alert recalled-alert" *ngIf="showRecallWithNames">
							<div class="alert-header">
								<div class="alert-icon">
									<i class="fas fa-arrow-rotate-left"></i>
								</div>
								<div class="alert-title">
									<h6 class="mb-0">Form Recalled</h6>
									<small class="text-muted">Action required from administrator</small>
								</div>
								<button type="button" class="alert-close-btn" (click)="showRecallWithNames = false" aria-label="Close">
									<i class="fas fa-times"></i>
								</button>
							</div>
							<div class="alert-content" *ngIf="pageSpecificFormObject.rejectionMessage">
								<p class="mb-0">{{ pageSpecificFormObject.rejectionMessage }}</p>
							</div>
						</div>

						<!-- Shared With Message -->
						<div class="status-alert shared-alert" *ngIf="showSharedWithNames">
							<div class="alert-header">
								<div class="alert-icon">
									<i class="fas fa-share-alt"></i>
								</div>
								<div class="alert-title">
									<h6 class="mb-0">Form Shared</h6>
									<small class="text-muted">Shared with: {{ getSharedWith() }}</small>
								</div>
								<button type="button" class="alert-close-btn" (click)="closeAlert()" aria-label="Close">
									<i class="fas fa-times"></i>
								</button>
							</div>
							<div class="alert-content" *ngIf="pageSpecificFormObject.sharingMessage">
								<strong class="content-label">Message:</strong>
								<p class="mb-0">{{ pageSpecificFormObject.sharingMessage }}</p>
							</div>
						</div>

						<!-- Returned Message -->
						<div class="status-alert returned-alert" *ngIf="showResentWithNames">
							<div class="alert-header">
								<div class="alert-icon">
									<i class="fas fa-undo"></i>
								</div>
								<div class="alert-title">
									<h6 class="mb-0">Form Returned</h6>
									<small class="text-muted">Requires revision and resubmission</small>
								</div>
								<button type="button" class="alert-close-btn" (click)="showResentWithNames = false" aria-label="Close">
									<i class="fas fa-times"></i>
								</button>
							</div>
							<div class="alert-content" *ngIf="pageSpecificFormObject.rejectionMessage">
								<strong class="content-label">Reason:</strong>
								<p class="mb-0">{{ pageSpecificFormObject.rejectionMessage }}</p>
							</div>
						</div>

						<!-- Submitted for Approval Message -->
						<div class="status-alert approval-alert" *ngIf="showSubmitForApprovalWithNames">
							<div class="alert-header">
								<div class="alert-icon">
									<i class="fas fa-paper-plane"></i>
								</div>
								<div class="alert-title">
									<h6 class="mb-0">Submitted for Approval</h6>
									<small class="text-muted">Awaiting review from administrator</small>
								</div>
								<button type="button" class="alert-close-btn" (click)="closeAlert1()" aria-label="Close">
									<i class="fas fa-times"></i>
								</button>
							</div>
							<div class="alert-content" *ngIf="pageSpecificFormObject.rejectionMessage">
								<strong class="content-label">Note:</strong>
								<p class="mb-0">{{ pageSpecificFormObject.rejectionMessage }}</p>
							</div>
						</div>

						<!-- Reverted Message -->
						<div class="status-alert reverted-alert" *ngIf="showRejectionReason">
							<div class="alert-header">
								<div class="alert-icon">
									<i class="fas fa-exclamation-triangle"></i>
								</div>
								<div class="alert-title">
									<h6 class="mb-0">Form Reverted</h6>
									<small class="text-muted">Changes required before approval</small>
								</div>
								<button type="button" class="alert-close-btn" (click)="showRejectionReason = false" aria-label="Close">
									<i class="fas fa-times"></i>
								</button>
							</div>
							<div class="alert-content" *ngIf="pageSpecificFormObject.rejectionMessage">
								<strong class="content-label">Reason:</strong>
								<p class="mb-0">{{ pageSpecificFormObject.rejectionMessage }}</p>
							</div>
						</div>

						<!-- Coordinator Remarks Message -->
						<div class="status-alert returned-alert" *ngIf="showCoordinatorRemarks">
							<div class="alert-header">
								<div class="alert-icon">
									<i class="fas fa-comment-alt"></i>
								</div>
								<div class="alert-title">
									<h6 class="mb-0">Remarks</h6>
									<small class="text-muted">Message from the IQAC</small>
								</div>
								<button type="button" class="alert-close-btn" (click)="showCoordinatorRemarks = false" aria-label="Close">
									<i class="fas fa-times"></i>
								</button>
							</div>
							<div class="alert-content" *ngIf="pageSpecificFormObject.rejectionMessage">
								<strong class="content-label">Note:</strong>
								<p class="mb-0">{{ pageSpecificFormObject.rejectionMessage }}</p>
							</div>
						</div>
					</div>
				</div>
			</div>

			<!-- User Information Section -->
			<div class="sheet-section user-section">
				<div class="section-header">
					<i class="fas fa-user"></i>
					<span>User Information</span>
				</div>

				<div class="section-content">
					<div class="user-info-detailed">
						<div class="user-avatar-large">
							<i class="fas fa-user-circle"></i>
						</div>
						<div class="user-details-full">
							<h6 class="user-full-name">
								<span *ngIf="userProfile.salutation">{{ userProfile.salutation.label }}. </span>
								{{ userProfile.firstName }}{{ userProfile.middleName ? ' ' + userProfile.middleName : '' }} {{ userProfile.lastName }}
							</h6>
							<div class="contact-details">
								<div class="contact-item" *ngIf="userProfile.mobileNumber">
									<i class="fas fa-phone"></i>
									<span>{{ userProfile.mobileNumber }}</span>
								</div>
								<div class="contact-item" *ngIf="userProfile?.emailId">
									<i class="fas fa-envelope"></i>
									<span>{{ userProfile.emailId }}</span>
								</div>
							</div>
						</div>
					</div>

					<!-- User Roles -->
					<div class="user-roles-section" *ngIf="formTypeId == 1 && userProfile.responsiblities?.length > 0">
						<div class="roles-title">
							<i class="fas fa-id-badge"></i>
							<span>Roles & Responsibilities</span>
						</div>
						<div class="roles-grid">
							<div class="role-item" *ngFor="let resp of userProfile.responsiblities">
								<div class="role-name">{{ resp?.designationLabel }}</div>
								<div class="role-dept" *ngIf="resp.department">({{ resp.department.name }})</div>
							</div>
						</div>
					</div>
				</div>
			</div></div
		></div
	></div
>
